<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <v-card-title>
            <h3>Ubah Data Ruangan</h3>
          </v-card-title>
          <v-snackbar
            v-model="show"
            multi-line="true"
            top="true"
            color="green"
          >
            {{ notifMsg }}
            <v-btn
              color="pink"
              flat
              @click="show = false"
            >
              Tutup
            </v-btn>
          </v-snackbar>
          <v-snackbar
            v-model="show2"
            multi-line="true"
            top="true"
            color="red"
          >
            {{ notifMsg }}
            <v-btn
              color="pink"
              flat
              @click="show2 = false"
            >
              Tutup
            </v-btn>
          </v-snackbar>
          <v-card-text>
            <v-form class="px-3">
              <v-select
                name="lokasi"
                label="Lokasi"
                :items="lokasi"
                v-model="idLokasi"
                disabled>
              </v-select>
              <v-select
                name="gedung"
                label="Gedung"
                :items="gedung"
                v-model="form.idGedung.id"
                disabled>
              </v-select>
              <v-text-field label="Kode Ruangan"
                            v-model="form.kodeRuangan"
                            disabled>
              </v-text-field>
              <div class="red--text lighten-1--text" v-if="$v.form.namaRuangan.$error" style="font-size: x-small"><i>Nama Ruangan Harus Diisi</i></div>
              <v-text-field label="*Nama Ruangan"
                            v-model="form.namaRuangan"
                            :class="{'is-invalid': $v.form.namaRuangan.$error}"
                            :rules="namaRuanganRules">
              </v-text-field>
              <v-text-field
                label="Lantai"
                v-model="form.lantai"
                disabled>
              </v-text-field>
              <div class="red--text lighten-1--text" v-if="$v.form.kapasitasMaksimal.$error" style="font-size: x-small"><i>Input Kapasitas Maksimal Harus angka</i></div>
              <v-text-field
                label="*Kapasitas"
                v-model="form.kapasitasMaksimal"
                :class="{'is-invalid': $v.form.kapasitasMaksimal.$error}"
                :rules="kapasitasMaksimalRules">
              </v-text-field>
              <v-select
                name="multiple"
                label="Multiple Class"
                :items="multiple"
                v-model="form.isMultipleClassAllowed">
              </v-select>
              <div class="red--text lighten-1--text" v-if="$v.form.idJenisRuangan.id.$error" style="font-size: x-small"><i>*Jenis Ruangan Harus Dipilih</i></div>
              <v-select
                name="jenis"
                label="*Jenis Ruangan"
                :items="jenisRuangan"
                v-model="form.idJenisRuangan.id"
                :class="{'is-invalid': $v.form.idJenisRuangan.id.$error}">
              </v-select>
              <div class="red--text lighten-1--text" v-if="$v.form.idStatusAset.id.$error" style="font-size: x-small"><i>*Status Ruangan Harus Dipilih</i></div>
              <v-select
                name="status"
                label="*Kondisi Ruangan"
                :items="statusAset"
                v-model="form.idStatusAset.id"
                :class="{'is-invalid': $v.form.idStatusAset.id.$error}">
              </v-select>
              <v-card-actions class="justify-center">
                <v-btn
                  style="width:120px;"
                  color="blue"
                  @click="onUpdate">
                  <v-icon left>
                    fa fa-check
                  </v-icon>
                    Simpan
                </v-btn>
                <v-btn
                  style="width:120px;"
                  color="red"
                  @click="onBatal">
                  <v-icon left>
                    fa fa-times
                  </v-icon>
                  Batal
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {base} from "../../setup-axios"
  import {required, integer} from "vuelidate/lib/validators"
  import {createJWT,getJWT} from "../../store/module/helper";
  import {isNotNull} from "../../validation";
  import { mapGetters,  mapActions} from 'vuex'

  const regexNamaRuangan = new RegExp(/^[a-zA-Z0-9 \.\-]*$/)
  const regexKapasitasAndLantai = new RegExp(/^[0-9 ]*$/)

    export default {
      name: "Edit",
      data() {
        return {
          namaRuanganRules: [
              v => regexNamaRuangan.test(v) || 'Nama Ruangan Hanya Boleh Terdiri Dari Huruf, Angka, Tanda Titik ".", dan Tanda Strip "-"',
            ],
          kapasitasMaksimalRules: [ 
              v => regexKapasitasAndLantai.test(v) || 'Kapasitas Harus Benbentuk Angka',
          ],
          form : {},
          update : {
            namaRuangan : "",
            kodeRuangan : "",
            kapasitasMaksimal : "",
            isMultipleClassAllowed : "",
            lantai : "",
            idJenisRuangan: null,
            idStatusAset: null,
            idGedung: null,
          },
          multiple : [
            {
              text : "Ya",
              value : true
            },
            {
              text : "Tidak",
              value : false
            }
          ],

          gedung:[],
          lokasi:[],
          idLokasi:"",
          jenisRuangan: [],
          statusAset: [],
          show : false,
          notifMsg : ''
        }
      },

      validations: {
        idLokasi : {
          isNotNull
        },
        // idGedung : {
        //   isNotNull
        // },
        // idJenis : {
        //   isNotNull
        // },
        // idStatus : {
        //   isNotNull
        // },
        form : {
          namaRuangan: {
            required
          },
          idGedung: {
            id : {
              isNotNull
            }
          },
          idJenisRuangan: {
            id : {
              isNotNull
            }
          },
          idStatusAset: {
            id : {
              isNotNull
            }
          },
          kapasitasMaksimal: {
            integer
          }
        }
      },

      created(){
        base.get("ruangan/" + this.$route.params.id ,
          {
            headers: {
              'Authorization' : createJWT()
            }
          }).then((resp) => {
          this.form = resp.data.resultById
          this.idLokasi = resp.data.resultById.idGedung.idLokasi.id
        })

        base.get("lokasi/dropdown" ,
          {
            headers: {
              'Authorization' : createJWT()
            }
          }).then((resp) => {
          for(var i=0; i < resp.data.result.length;i++){
            this.lokasi.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
          }
        })

        base.get("gedung/dropdown" ,
          {
            headers: {
              'Authorization' : createJWT()
            }
          }).then((resp) => {
          for(var i=0; i < resp.data.result.length;i++){
            this.gedung.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
          }
        })

        base.get("jenisRuangan/dropdown" ,
          {
            headers: {
              'Authorization' : createJWT()
            }
          }).then((resp) => {
          for(var i=0; i < resp.data.result.length;i++){
            this.jenisRuangan.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
          }
        })

        base.get("statusAset/dropdown" ,
          {
            headers: {
              'Authorization' : createJWT()
            }
          }).then((resp) => {
          for(var i=0; i < resp.data.result.length;i++){
            this.statusAset.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
          }
        })
      },

      computed:{
        ...mapGetters(["snackbar"])
      },

      methods : {
        ...mapActions(["fetchSnackbar", "fetchMsgSnackbar", "fetchPathSnackbar"]),
        onBatal() {
          this.$router.push("/ruangan/ruangan")
        },

        onUpdate() {
          this.$v.$touch();
          if(this.$v.$error) return

          this.update.namaRuangan = this.form.namaRuangan
          this.update.kodeRuangan = this.form.kodeRuangan
          this.update.kapasitasMaksimal = this.form.kapasitasMaksimal
          this.update.isMultipleClassAllowed = this.form.isMultipleClassAllowed
          this.update.lantai = this.form.lantai
          this.update.idJenisRuangan = this.form.idJenisRuangan.id
          this.update.idStatusAset = this.form.idStatusAset.id
          this.update.idGedung = this.form.idGedung.id

          var url = "ruangan/" + this.$route.params.id

          let thisVM = this

          base.put(url,this.update ,
            {
              headers: {
                'Authorization' : createJWT(),
                'token': getJWT()
              }
            }
            ).then((resp) => {
            console.log('Success');
            console.log(resp.data);
            thisVM.fetchSnackbar(true, 'Berhasil Mengubah data Ruangan', 'ruangan')
            thisVM.fetchMsgSnackbar("Berhasil Mengubah Data Ruangan")
            thisVM.fetchPathSnackbar("ruangan")
            thisVM.$router.push('/ruangan/ruangan')
          }).catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            thisVM.show2 = true
            thisVM.notifMsg = 'Gagal Mengubah data Ruangan'
            })
        }
      }
    }
</script>

<style scoped>

</style>